import type { DrillType } from "@-/dev.improve.haniverse.lib.drill.entities";
import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import { useLearnDeckNavigatorOptions } from "@-/dev.improve.haniverse.routes.nav.app.learn.deck.navigator";
import { useCallback } from "react";

/**
 * Opens the Learn deck on a review card's front. Kept as the entry point every review-opening
 * surface already uses (the summary's "Start Reviewing", undo, deep links); the deck route is the
 * only screen behind it.
 */
function useNavigator() {
  const getLearnDeckNavigatorOptions = useLearnDeckNavigatorOptions();

  return useCallback(
    ({
      contextSentence = null,
      drillType,
      grapheme,
      studyMode = "manual",
    }: {
      contextSentence?: string | null;
      drillType: DrillType;
      grapheme: string;
      /** Accepted for callers that still name the reading; the drill type already carries it. */
      pinyin?: string | undefined;
      studyMode?: "manual" | "voice";
    }) =>
      getLearnDeckNavigatorOptions({
        contextSentence: contextSentence ?? null,
        drillType,
        face: "front",
        grapheme,
        kind: "review",
        mode: studyMode ?? "manual",
        view: "study",
      }),
    [getLearnDeckNavigatorOptions],
  );
}

export const useDrillPageNavigator = createPageNavigator({
  useNavigator,
});
